import { SequenceHelper } from "@swivl-mono/helpers";
import { FMSType, LocationVarKey, SequenceEnabledStatus, SequenceInterface, SequenceSubType } from "@swivl-mono/types";
import { OptionsHelper } from "@swivl-mono/ui";
import { useEffect, useMemo } from "react";

import { IF_ALL, IS_EQUAL, IS_NOT_EQUAL } from "../../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  PageHeader,
  Section,
  SectionHeader,
  SwitchRow,
  TextAreaRow
} from "../../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../../Hooks/usePropertiesGetLocationIds";
import SequencesModel from "../../../../Models/Sequences/SequencesModel";

export const PAGE_KEYS: LocationVarKey[] = [
  LocationVarKey.WantsCronReceiptsMoveIn,
  LocationVarKey.HasFMSPlusMoveInNotes,
  LocationVarKey.SequenceMoveInDay00ActuallyEnabled,
  LocationVarKey.SequenceMoveInDay00MinTime,
  LocationVarKey.SequenceMoveInDay00MaxTime,
  LocationVarKey.FMSplushas0MoveInMethod,
  LocationVarKey.FMSplus0MoveIn1,
  LocationVarKey.FMSplus0MoveIn2,
  LocationVarKey.FMSplus0MoveIn3,
  LocationVarKey.FMSplus0MoveInReview,
  LocationVarKey.FMSplus0MoveInReferral,
  LocationVarKey.FMSplus0MoveInReferral1,
  LocationVarKey.SequenceMoveInDay01Enabled,
  LocationVarKey.SequenceMoveInDay01Time,
  LocationVarKey.FMSplushasp1MoveInMethod,
  LocationVarKey.FMSplusp1MoveIn1,
  LocationVarKey.FMSplusp1MoveIn2,
  LocationVarKey.FMSplusp1MoveIn3,
  LocationVarKey.FMSplushasp1MoveInReview,
  LocationVarKey.FMSplushasp1MoveInReferral,
  LocationVarKey.FMSplushasp1MoveInReferral1,
  LocationVarKey.SequenceMoveInDay02Enabled,
  LocationVarKey.SequenceMoveInDay02Time,
  LocationVarKey.SequenceMoveInDay03Enabled,
  LocationVarKey.SequenceMoveInDay03Time,
  LocationVarKey.FMSplushasp3MoveInMethod,
  LocationVarKey.FMSplusp3MoveIn1,
  LocationVarKey.FMSplusp3MoveIn2,
  LocationVarKey.FMSplusp3MoveIn3,
  LocationVarKey.FMSplushasp3MoveInReview,
  LocationVarKey.FMSplushasp3MoveInReferral,
  LocationVarKey.FMSplushasp3MoveInReferral1,
  LocationVarKey.SequenceMoveInDay05Enabled,
  LocationVarKey.SequenceMoveInDay05Time,
  LocationVarKey.FMSplushasp5MoveInMethod,
  LocationVarKey.FMSplusp5MoveIn1,
  LocationVarKey.FMSplusp5MoveIn2,
  LocationVarKey.FMSplusp5MoveIn3,
  LocationVarKey.FMSplushasp5MoveInReview,
  LocationVarKey.FMSplushasp5MoveInReferral,
  LocationVarKey.FMSplushasp5MoveInReferral1,
  LocationVarKey.SequenceMoveInDay07Enabled,
  LocationVarKey.SequenceMoveInDay07Time,
  LocationVarKey.FMSplushasp7MoveInMethod,
  LocationVarKey.FMSplusp7MoveIn1,
  LocationVarKey.FMSplusp7MoveIn2,
  LocationVarKey.FMSplusp7MoveIn3,
  LocationVarKey.FMSplushasp7MoveInReview,
  LocationVarKey.FMSplushasp7MoveInReferral,
  LocationVarKey.FMSplushasp7MoveInReferral1,
  LocationVarKey.SequenceMoveInDay10Enabled,
  LocationVarKey.SequenceMoveInDay10Time,
  LocationVarKey.FMSplushasp10MoveInMethod,
  LocationVarKey.FMSplusp10MoveIn1,
  LocationVarKey.FMSplusp10MoveIn2,
  LocationVarKey.FMSplusp10MoveIn3,
  LocationVarKey.FMSplushasp10MoveInReview,
  LocationVarKey.FMSplushasp10MoveInReferral,
  LocationVarKey.FMSplushasp10MoveInReferral1,
  LocationVarKey.SequenceMoveInDay14Enabled,
  LocationVarKey.SequenceMoveInDay14Time,
  LocationVarKey.FMSplushasp14MoveInMethod,
  LocationVarKey.FMSplusp14MoveIn1,
  LocationVarKey.FMSplusp14MoveIn2,
  LocationVarKey.FMSplusp14MoveIn3,
  LocationVarKey.FMSplushasp14MoveInReview,
  LocationVarKey.FMSplushasp14MoveInReferral,
  LocationVarKey.FMSplushasp14MoveInReferral1,
  LocationVarKey.SequenceMoveInDay30Enabled,
  LocationVarKey.SequenceMoveInDay30Time,
  LocationVarKey.FMSplushasp30MoveInMethod,
  LocationVarKey.FMSplusp30MoveIn1,
  LocationVarKey.FMSplusp30MoveIn2,
  LocationVarKey.FMSplusp30MoveIn3,
  LocationVarKey.FMSplushasp30MoveInReview,
  LocationVarKey.FMSplushasp30MoveInReferral,
  LocationVarKey.FMSplushasp30MoveInReferral1,
  LocationVarKey.SequenceMoveInDay90Enabled,
  LocationVarKey.SequenceMoveInDay90Time,
  LocationVarKey.FMSplushasp90MoveInMethod,
  LocationVarKey.FMSplusp90MoveIn1,
  LocationVarKey.FMSplusp90MoveIn2,
  LocationVarKey.FMSplushasp90MoveInReview,
  LocationVarKey.FMSplushasp90MoveInReferral,
  LocationVarKey.FMSplushasp90MoveInReferral1
];

export default function WorksheetView() {
  const { sequences } = SequencesModel.useState();
  const page = usePropertiesGetLocationIds();
  useEffect(() => {
    SequencesModel.load(false);
  }, []);
  const sequenceArray: SequenceInterface[] | undefined = useMemo(() => {
    if (sequences) {
      return Object.values(sequences);
    }
    return undefined;
  }, [sequences]);

  return (
    <>
      <PageHeader
        {...page}
        subheading="These sync with your FMS daily and will trigger a workflow to communicate with your customers around move in."
      >
        Move In Sequences
      </PageHeader>
      <SwitchRow {...page} keyName={LocationVarKey.WantsCronReceiptsMoveIn} label="Send Email Receipts" />
      <SwitchRow
        {...page}
        hideIf={IF_ALL([
          IS_NOT_EQUAL(LocationVarKey.FMSType, FMSType.SiteLink),
          IS_NOT_EQUAL(LocationVarKey.FMSType, FMSType.StorEdge),
          IS_NOT_EQUAL(LocationVarKey.FMSType, FMSType.SSMCloud),
          IS_NOT_EQUAL(LocationVarKey.FMSType, FMSType.QuikStor),
          IS_NOT_EQUAL(LocationVarKey.FMSType, FMSType.Monument),
          IS_NOT_EQUAL(LocationVarKey.FMSType, FMSType.Yardi)
        ])}
        keyName={LocationVarKey.HasFMSPlusMoveInNotes}
        label="Add FMS Notes"
      />

      {sequenceArray && SequenceHelper.isAnySequenceSubType(SequenceSubType.MOVE_IN_DAY_00, sequenceArray) && (
        <>
          <SectionHeader {...page}>Day of move in</SectionHeader>
          <DropdownRow
            {...page}
            label="Enabled"
            marginTop
            keyName={LocationVarKey.SequenceMoveInDay00ActuallyEnabled}
            options={[
              { label: "Enabled", value: "ENABLED" },
              { label: "Disabled", value: "DISABLED" },
              { label: "Simulated", value: "SIMULATED" }
            ]}
          />
          <Section {...page} hideIf={IS_EQUAL(LocationVarKey.SequenceMoveInDay00Enabled, SequenceEnabledStatus.DISABLED)}>
            <DropdownRow
              {...page}
              label="Send Between Start"
              marginTop
              keyName={LocationVarKey.SequenceMoveInDay00MinTime}
              options={OptionsHelper.hoursOptionsLocalized()}
            />
            <DropdownRow
              {...page}
              label="Send Between End"
              marginTop
              keyName={LocationVarKey.SequenceMoveInDay00MaxTime}
              options={OptionsHelper.hoursOptionsLocalized()}
            />
            <DropdownRow
              {...page}
              marginTop
              label=" Channel"
              keyName={LocationVarKey.FMSplushas0MoveInMethod}
              options={[
                {
                  label: "Email",
                  value: "Email"
                },
                {
                  label: "SMS",
                  value: "SMS"
                },
                {
                  label: "Email & SMS",
                  value: "Both"
                }
              ]}
            />
            <Section {...page} hideIf={IS_EQUAL(LocationVarKey.FMSplushas0MoveInMethod, "Email")}>
              <TextAreaRow {...page} marginTop label=" SMS Message 1" keyName={LocationVarKey.FMSplus0MoveIn1} />
              <TextAreaRow
                {...page}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplus0MoveIn2}
                enableSwitchVar={LocationVarKey.FMSplus0MoveIn2Enabled}
              />
              <TextAreaRow
                {...page}
                marginTop
                label=" SMS Message 3 (Optional)"
                keyName={LocationVarKey.FMSplus0MoveIn3}
                enableSwitchVar={LocationVarKey.FMSplus0MoveIn3Enabled}
              />
            </Section>
            <SwitchRow {...page} keyName={LocationVarKey.FMSplus0MoveInReview} label="Start Review Solicitation" />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplus0MoveInReferral} label="Start Referral Solicitation" />
            <Section {...page} hideIf={IS_EQUAL(LocationVarKey.FMSplushas0MoveInMethod, "Email")}>
              <TextAreaRow
                {...page}
                hideIf={IS_NOT_EQUAL(LocationVarKey.FMSplus0MoveInReferral, "1")}
                marginTop
                label=" SMS Referral Message"
                keyName={LocationVarKey.FMSplus0MoveInReferral1}
              />
            </Section>
          </Section>
        </>
      )}

      {sequenceArray && SequenceHelper.isAnySequenceSubType(SequenceSubType.MOVE_IN_DAY_01, sequenceArray) && (
        <>
          <SectionHeader {...page}>1 day after move in</SectionHeader>
          <DropdownRow
            {...page}
            label="Enabled"
            marginTop
            keyName={LocationVarKey.SequenceMoveInDay01Enabled}
            options={[
              { label: "Enabled", value: SequenceEnabledStatus.ENABLED },
              { label: "Disabled", value: SequenceEnabledStatus.DISABLED },
              { label: "Simulated", value: SequenceEnabledStatus.SIMULATED }
            ]}
          />
          <Section {...page} hideIf={IS_EQUAL(LocationVarKey.SequenceMoveInDay01Enabled, SequenceEnabledStatus.DISABLED)}>
            <DropdownRow
              {...page}
              label="Time"
              marginTop
              keyName={LocationVarKey.SequenceMoveInDay01Time}
              options={OptionsHelper.hoursOptionsLocalized()}
            />
            <DropdownRow
              {...page}
              marginTop
              label=" Channel"
              keyName={LocationVarKey.FMSplushasp1MoveInMethod}
              options={[
                {
                  label: "Email",
                  value: "Email"
                },
                {
                  label: "SMS",
                  value: "SMS"
                },
                {
                  label: "Email & SMS",
                  value: "Both"
                }
              ]}
            />
            <Section {...page} hideIf={IS_EQUAL(LocationVarKey.FMSplushasp1MoveInMethod, "Email")}>
              <TextAreaRow {...page} marginTop label=" SMS Message 1" keyName={LocationVarKey.FMSplusp1MoveIn1} />
              <TextAreaRow
                {...page}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplusp1MoveIn2}
                enableSwitchVar={LocationVarKey.FMSplusp1MoveIn2Enabled}
              />
              <TextAreaRow
                {...page}
                marginTop
                label=" SMS Message 3 (Optional)"
                keyName={LocationVarKey.FMSplusp1MoveIn3}
                enableSwitchVar={LocationVarKey.FMSplusp1MoveIn3Enabled}
              />
            </Section>
            <SwitchRow {...page} keyName={LocationVarKey.FMSplushasp1MoveInReview} label="Start Review Solicitation" />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplushasp1MoveInReferral} label="Start Referral Solicitation" />
            <Section {...page} hideIf={IS_EQUAL(LocationVarKey.FMSplushasp1MoveInMethod, "Email")}>
              <TextAreaRow
                {...page}
                hideIf={IS_NOT_EQUAL(LocationVarKey.FMSplushasp1MoveInReferral, "1")}
                marginTop
                label=" SMS Referral Message"
                keyName={LocationVarKey.FMSplushasp1MoveInReferral1}
              />
            </Section>
          </Section>
        </>
      )}

      {/* {sequenceArray && SequenceHelper.isAnySequenceSubType(SequenceSubType.MOVE_IN_DAY_02, sequenceArray) && (
        <>
          <SectionHeader {...page}>2 days after move in</SectionHeader>
          <DropdownRow
            {...page}
            label="Enabled"
            marginTop
            keyName={LocationVarKey.SequenceMoveInDay02Enabled}
            options={[
              { label: "Enabled", value: SequenceEnabledStatus.ENABLED },
              { label: "Disabled", value: SequenceEnabledStatus.DISABLED },
              { label: "Simulated", value: SequenceEnabledStatus.SIMULATED },
            ]}
          />
          <Section {...page} hideIf={IS_EQUAL(LocationVarKey.SequenceMoveInDay02Enabled, SequenceEnabledStatus.DISABLED)}>
            <DropdownRow
              {...page}
              label="Time"
              marginTop
              keyName={LocationVarKey.SequenceMoveInDay02Time}
              options={OptionsHelper.hoursOptionsLocalized()}
            />
          </Section>
        </>
      )} */}

      {sequenceArray && SequenceHelper.isAnySequenceSubType(SequenceSubType.MOVE_IN_DAY_03, sequenceArray) && (
        <>
          <SectionHeader {...page}>3 days after move in</SectionHeader>
          <DropdownRow
            {...page}
            label="Enabled"
            marginTop
            keyName={LocationVarKey.SequenceMoveInDay03Enabled}
            options={[
              { label: "Enabled", value: SequenceEnabledStatus.ENABLED },
              { label: "Disabled", value: SequenceEnabledStatus.DISABLED },
              { label: "Simulated", value: SequenceEnabledStatus.SIMULATED }
            ]}
          />
          <Section {...page} hideIf={IS_EQUAL(LocationVarKey.SequenceMoveInDay03Enabled, SequenceEnabledStatus.DISABLED)}>
            <DropdownRow
              {...page}
              label="Time"
              marginTop
              keyName={LocationVarKey.SequenceMoveInDay03Time}
              options={OptionsHelper.hoursOptionsLocalized()}
            />
            <DropdownRow
              {...page}
              marginTop
              label=" Channel"
              keyName={LocationVarKey.FMSplushasp3MoveInMethod}
              options={[
                {
                  label: "Email",
                  value: "Email"
                },
                {
                  label: "SMS",
                  value: "SMS"
                },
                {
                  label: "Email & SMS",
                  value: "Both"
                }
              ]}
            />
            <Section {...page} hideIf={IS_EQUAL(LocationVarKey.FMSplushasp3MoveInMethod, "Email")}>
              <TextAreaRow {...page} marginTop label=" SMS Message 1" keyName={LocationVarKey.FMSplusp3MoveIn1} />
              <TextAreaRow
                {...page}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplusp3MoveIn2}
                enableSwitchVar={LocationVarKey.FMSplusp3MoveIn2Enabled}
              />
              <TextAreaRow
                {...page}
                marginTop
                label=" SMS Message 3 (Optional)"
                keyName={LocationVarKey.FMSplusp3MoveIn3}
                enableSwitchVar={LocationVarKey.FMSplusp3MoveIn3Enabled}
              />
            </Section>
            <SwitchRow {...page} keyName={LocationVarKey.FMSplushasp3MoveInReview} label="Start Review Solicitation" />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplushasp3MoveInReferral} label="Start Referral Solicitation" />
            <Section {...page} hideIf={IS_EQUAL(LocationVarKey.FMSplushasp3MoveInMethod, "Email")}>
              <TextAreaRow
                {...page}
                hideIf={IS_NOT_EQUAL(LocationVarKey.FMSplushasp3MoveInReferral, "1")}
                marginTop
                label=" SMS Referral Message"
                keyName={LocationVarKey.FMSplushasp3MoveInReferral1}
              />
            </Section>
          </Section>
        </>
      )}

      {sequenceArray && SequenceHelper.isAnySequenceSubType(SequenceSubType.MOVE_IN_DAY_05, sequenceArray) && (
        <>
          <SectionHeader {...page}>5 days after move in</SectionHeader>
          <DropdownRow
            {...page}
            label="Enabled"
            marginTop
            keyName={LocationVarKey.SequenceMoveInDay05Enabled}
            options={[
              { label: "Enabled", value: SequenceEnabledStatus.ENABLED },
              { label: "Disabled", value: SequenceEnabledStatus.DISABLED },
              { label: "Simulated", value: SequenceEnabledStatus.SIMULATED }
            ]}
          />
          <Section {...page} hideIf={IS_EQUAL(LocationVarKey.SequenceMoveInDay05Enabled, SequenceEnabledStatus.DISABLED)}>
            <DropdownRow
              {...page}
              label="Time"
              marginTop
              keyName={LocationVarKey.SequenceMoveInDay05Time}
              options={OptionsHelper.hoursOptionsLocalized()}
            />
            <DropdownRow
              {...page}
              marginTop
              label=" Channel"
              keyName={LocationVarKey.FMSplushasp5MoveInMethod}
              options={[
                {
                  label: "Email",
                  value: "Email"
                },
                {
                  label: "SMS",
                  value: "SMS"
                },
                {
                  label: "Email & SMS",
                  value: "Both"
                }
              ]}
            />
            <Section {...page} hideIf={IS_EQUAL(LocationVarKey.FMSplushasp5MoveInMethod, "Email")}>
              <TextAreaRow {...page} marginTop label=" SMS Message 1" keyName={LocationVarKey.FMSplusp5MoveIn1} />
              <TextAreaRow
                {...page}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplusp5MoveIn2}
                enableSwitchVar={LocationVarKey.FMSplusp5MoveIn2Enabled}
              />
              <TextAreaRow
                {...page}
                marginTop
                label=" SMS Message 3 (Optional)"
                keyName={LocationVarKey.FMSplusp5MoveIn3}
                enableSwitchVar={LocationVarKey.FMSplusp5MoveIn3Enabled}
              />
            </Section>
            <SwitchRow {...page} keyName={LocationVarKey.FMSplushasp5MoveInReview} label="Start Review Solicitation" />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplushasp5MoveInReferral} label="Start Referral Solicitation" />
            <Section {...page} hideIf={IS_EQUAL(LocationVarKey.FMSplushasp5MoveInMethod, "Email")}>
              <TextAreaRow
                {...page}
                hideIf={IS_NOT_EQUAL(LocationVarKey.FMSplushasp5MoveInReferral, "1")}
                marginTop
                label=" SMS Referral Message"
                keyName={LocationVarKey.FMSplushasp5MoveInReferral1}
              />
            </Section>
          </Section>
        </>
      )}

      {sequenceArray && SequenceHelper.isAnySequenceSubType(SequenceSubType.MOVE_IN_DAY_07, sequenceArray) && (
        <>
          <SectionHeader {...page}>7 days after move in</SectionHeader>
          <DropdownRow
            {...page}
            label="Enabled"
            marginTop
            keyName={LocationVarKey.SequenceMoveInDay07Enabled}
            options={[
              { label: "Enabled", value: SequenceEnabledStatus.ENABLED },
              { label: "Disabled", value: SequenceEnabledStatus.DISABLED },
              { label: "Simulated", value: SequenceEnabledStatus.SIMULATED }
            ]}
          />
          <Section {...page} hideIf={IS_EQUAL(LocationVarKey.SequenceMoveInDay07Enabled, SequenceEnabledStatus.DISABLED)}>
            <DropdownRow
              {...page}
              label="Time"
              marginTop
              keyName={LocationVarKey.SequenceMoveInDay07Time}
              options={OptionsHelper.hoursOptionsLocalized()}
            />
            <DropdownRow
              {...page}
              marginTop
              label=" Channel"
              keyName={LocationVarKey.FMSplushasp7MoveInMethod}
              options={[
                {
                  label: "Email",
                  value: "Email"
                },
                {
                  label: "SMS",
                  value: "SMS"
                },
                {
                  label: "Email & SMS",
                  value: "Both"
                }
              ]}
            />
            <Section {...page} hideIf={IS_EQUAL(LocationVarKey.FMSplushasp7MoveInMethod, "Email")}>
              <TextAreaRow {...page} marginTop label=" SMS Message 1" keyName={LocationVarKey.FMSplusp7MoveIn1} />
              <TextAreaRow
                {...page}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplusp7MoveIn2}
                enableSwitchVar={LocationVarKey.FMSplusp7MoveIn2Enabled}
              />
              <TextAreaRow
                {...page}
                marginTop
                label=" SMS Message 3 (Optional)"
                keyName={LocationVarKey.FMSplusp7MoveIn3}
                enableSwitchVar={LocationVarKey.FMSplusp7MoveIn3Enabled}
              />
            </Section>
            <SwitchRow {...page} keyName={LocationVarKey.FMSplushasp7MoveInReview} label="Start Review Solicitation" />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplushasp7MoveInReferral} label="Start Referral Solicitation" />
            <Section {...page} hideIf={IS_EQUAL(LocationVarKey.FMSplushasp7MoveInMethod, "Email")}>
              <TextAreaRow
                {...page}
                hideIf={IS_NOT_EQUAL(LocationVarKey.FMSplushasp7MoveInReferral, "1")}
                marginTop
                label=" SMS Referral Message"
                keyName={LocationVarKey.FMSplushasp7MoveInReferral1}
              />
            </Section>
          </Section>
        </>
      )}

      {sequenceArray && SequenceHelper.isAnySequenceSubType(SequenceSubType.MOVE_IN_DAY_10, sequenceArray) && (
        <>
          <SectionHeader {...page}>10 days after move in</SectionHeader>
          <DropdownRow
            {...page}
            label="Enabled"
            marginTop
            keyName={LocationVarKey.SequenceMoveInDay10Enabled}
            options={[
              { label: "Enabled", value: SequenceEnabledStatus.ENABLED },
              { label: "Disabled", value: SequenceEnabledStatus.DISABLED },
              { label: "Simulated", value: SequenceEnabledStatus.SIMULATED }
            ]}
          />
          <Section {...page} hideIf={IS_EQUAL(LocationVarKey.SequenceMoveInDay10Enabled, SequenceEnabledStatus.DISABLED)}>
            <DropdownRow
              {...page}
              label="Time"
              marginTop
              keyName={LocationVarKey.SequenceMoveInDay10Time}
              options={OptionsHelper.hoursOptionsLocalized()}
            />
            <DropdownRow
              {...page}
              marginTop
              label=" Channel"
              keyName={LocationVarKey.FMSplushasp10MoveInMethod}
              options={[
                {
                  label: "Email",
                  value: "Email"
                },
                {
                  label: "SMS",
                  value: "SMS"
                },
                {
                  label: "Email & SMS",
                  value: "Both"
                }
              ]}
            />
            <Section {...page} hideIf={IS_EQUAL(LocationVarKey.FMSplushasp10MoveInMethod, "Email")}>
              <TextAreaRow {...page} marginTop label=" SMS Message 1" keyName={LocationVarKey.FMSplusp10MoveIn1} />
              <TextAreaRow
                {...page}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplusp10MoveIn2}
                enableSwitchVar={LocationVarKey.FMSplusp10MoveIn2Enabled}
              />
              <TextAreaRow
                {...page}
                marginTop
                label=" SMS Message 3 (Optional)"
                keyName={LocationVarKey.FMSplusp10MoveIn3}
                enableSwitchVar={LocationVarKey.FMSplusp10MoveIn3Enabled}
              />
            </Section>
            <SwitchRow {...page} keyName={LocationVarKey.FMSplushasp10MoveInReview} label="Start Review Solicitation" />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplushasp10MoveInReferral} label="Start Referral Solicitation" />
            <Section {...page} hideIf={IS_EQUAL(LocationVarKey.FMSplushasp10MoveInMethod, "Email")}>
              <TextAreaRow
                {...page}
                hideIf={IS_NOT_EQUAL(LocationVarKey.FMSplushasp10MoveInReferral, "1")}
                marginTop
                label=" SMS Referral Message"
                keyName={LocationVarKey.FMSplushasp10MoveInReferral1}
              />
            </Section>
          </Section>
        </>
      )}

      {sequenceArray && SequenceHelper.isAnySequenceSubType(SequenceSubType.MOVE_IN_DAY_14, sequenceArray) && (
        <>
          <SectionHeader {...page}>14 days after move in</SectionHeader>
          <DropdownRow
            {...page}
            label="Enabled"
            marginTop
            keyName={LocationVarKey.SequenceMoveInDay14Enabled}
            options={[
              { label: "Enabled", value: SequenceEnabledStatus.ENABLED },
              { label: "Disabled", value: SequenceEnabledStatus.DISABLED },
              { label: "Simulated", value: SequenceEnabledStatus.SIMULATED }
            ]}
          />
          <Section {...page} hideIf={IS_EQUAL(LocationVarKey.SequenceMoveInDay14Enabled, SequenceEnabledStatus.DISABLED)}>
            <DropdownRow
              {...page}
              label="Time"
              marginTop
              keyName={LocationVarKey.SequenceMoveInDay14Time}
              options={OptionsHelper.hoursOptionsLocalized()}
            />
            <DropdownRow
              {...page}
              marginTop
              label=" Channel"
              keyName={LocationVarKey.FMSplushasp14MoveInMethod}
              options={[
                {
                  label: "Email",
                  value: "Email"
                },
                {
                  label: "SMS",
                  value: "SMS"
                },
                {
                  label: "Email & SMS",
                  value: "Both"
                }
              ]}
            />
            <Section {...page} hideIf={IS_EQUAL(LocationVarKey.FMSplushasp14MoveInMethod, "Email")}>
              <TextAreaRow {...page} marginTop label=" SMS Message 1" keyName={LocationVarKey.FMSplusp14MoveIn1} />
              <TextAreaRow
                {...page}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplusp14MoveIn2}
                enableSwitchVar={LocationVarKey.FMSplusp14MoveIn2Enabled}
              />
              <TextAreaRow
                {...page}
                marginTop
                label=" SMS Message 3 (Optional)"
                keyName={LocationVarKey.FMSplusp14MoveIn3}
                enableSwitchVar={LocationVarKey.FMSplusp14MoveIn3Enabled}
              />
            </Section>
            <SwitchRow {...page} keyName={LocationVarKey.FMSplushasp14MoveInReview} label="Start Review Solicitation" />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplushasp14MoveInReferral} label="Start Referral Solicitation" />
            <Section {...page} hideIf={IS_EQUAL(LocationVarKey.FMSplushasp14MoveInMethod, "Email")}>
              <TextAreaRow
                {...page}
                hideIf={IS_NOT_EQUAL(LocationVarKey.FMSplushasp14MoveInReferral, "1")}
                marginTop
                label=" SMS Referral Message"
                keyName={LocationVarKey.FMSplushasp14MoveInReferral1}
              />
            </Section>
          </Section>
        </>
      )}

      {sequenceArray && SequenceHelper.isAnySequenceSubType(SequenceSubType.MOVE_IN_DAY_30, sequenceArray) && (
        <>
          <SectionHeader {...page}>30 days after move in</SectionHeader>
          <DropdownRow
            {...page}
            label="Enabled"
            marginTop
            keyName={LocationVarKey.SequenceMoveInDay30Enabled}
            options={[
              { label: "Enabled", value: SequenceEnabledStatus.ENABLED },
              { label: "Disabled", value: SequenceEnabledStatus.DISABLED },
              { label: "Simulated", value: SequenceEnabledStatus.SIMULATED }
            ]}
          />
          <Section {...page} hideIf={IS_EQUAL(LocationVarKey.SequenceMoveInDay30Enabled, SequenceEnabledStatus.DISABLED)}>
            <DropdownRow
              {...page}
              label="Time"
              marginTop
              keyName={LocationVarKey.SequenceMoveInDay30Time}
              options={OptionsHelper.hoursOptionsLocalized()}
            />
            <DropdownRow
              {...page}
              marginTop
              label=" Channel"
              keyName={LocationVarKey.FMSplushasp30MoveInMethod}
              options={[
                {
                  label: "Email",
                  value: "Email"
                },
                {
                  label: "SMS",
                  value: "SMS"
                },
                {
                  label: "Email & SMS",
                  value: "Both"
                }
              ]}
            />
            <Section {...page} hideIf={IS_EQUAL(LocationVarKey.FMSplushasp30MoveInMethod, "Email")}>
              <TextAreaRow {...page} marginTop label=" SMS Message 1" keyName={LocationVarKey.FMSplusp30MoveIn1} />
              <TextAreaRow
                {...page}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplusp30MoveIn2}
                enableSwitchVar={LocationVarKey.FMSplusp30MoveIn2Enabled}
              />
              <TextAreaRow
                {...page}
                marginTop
                label=" SMS Message 3 (Optional)"
                keyName={LocationVarKey.FMSplusp30MoveIn3}
                enableSwitchVar={LocationVarKey.FMSplusp30MoveIn3Enabled}
              />
            </Section>
            <SwitchRow {...page} keyName={LocationVarKey.FMSplushasp30MoveInReview} label="Start Review Solicitation" />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplushasp30MoveInReferral} label="Start Referral Solicitation" />
            <Section {...page} hideIf={IS_EQUAL(LocationVarKey.FMSplushasp30MoveInMethod, "Email")}>
              <TextAreaRow
                {...page}
                hideIf={IS_NOT_EQUAL(LocationVarKey.FMSplushasp30MoveInReferral, "1")}
                marginTop
                label=" SMS Referral Message"
                keyName={LocationVarKey.FMSplushasp30MoveInReferral1}
              />
            </Section>
          </Section>
        </>
      )}

      {sequenceArray && SequenceHelper.isAnySequenceSubType(SequenceSubType.MOVE_IN_DAY_90, sequenceArray) && (
        <>
          <SectionHeader {...page}>90 days after move in</SectionHeader>
          <DropdownRow
            {...page}
            label="Enabled"
            marginTop
            keyName={LocationVarKey.SequenceMoveInDay90Enabled}
            options={[
              { label: "Enabled", value: SequenceEnabledStatus.ENABLED },
              { label: "Disabled", value: SequenceEnabledStatus.DISABLED },
              { label: "Simulated", value: SequenceEnabledStatus.SIMULATED }
            ]}
          />
          <Section {...page} hideIf={IS_EQUAL(LocationVarKey.SequenceMoveInDay90Enabled, SequenceEnabledStatus.DISABLED)}>
            <DropdownRow
              {...page}
              label="Time"
              marginTop
              keyName={LocationVarKey.SequenceMoveInDay90Time}
              options={OptionsHelper.hoursOptionsLocalized()}
            />
            <DropdownRow
              {...page}
              marginTop
              label=" Channel"
              keyName={LocationVarKey.FMSplushasp90MoveInMethod}
              options={[
                {
                  label: "Email",
                  value: "Email"
                },
                {
                  label: "SMS",
                  value: "SMS"
                },
                {
                  label: "Email & SMS",
                  value: "Both"
                }
              ]}
            />
            <Section {...page} hideIf={IS_EQUAL(LocationVarKey.FMSplushasp90MoveInMethod, "Email")}>
              <TextAreaRow {...page} marginTop label=" SMS Message 1" keyName={LocationVarKey.FMSplusp90MoveIn1} />
              <TextAreaRow
                {...page}
                marginTop
                label=" SMS Message 2 (Optional)"
                keyName={LocationVarKey.FMSplusp90MoveIn2}
                enableSwitchVar={LocationVarKey.FMSplusp90MoveIn2Enabled}
              />
            </Section>
            <SwitchRow {...page} keyName={LocationVarKey.FMSplushasp90MoveInReview} label="Start Review Solicitation" />
            <SwitchRow {...page} keyName={LocationVarKey.FMSplushasp90MoveInReferral} label="Start Referral Solicitation" />
            <Section {...page} hideIf={IS_EQUAL(LocationVarKey.FMSplushasp90MoveInMethod, "Email")}>
              <TextAreaRow
                {...page}
                hideIf={IS_NOT_EQUAL(LocationVarKey.FMSplushasp90MoveInReferral, "1")}
                marginTop
                label=" SMS Referral Message"
                keyName={LocationVarKey.FMSplushasp90MoveInReferral1}
              />
            </Section>
          </Section>
        </>
      )}
    </>
  );
}
